import React from 'react';
import { Popper, Paper } from '@material-ui/core';
import { TooltipPosition } from '../hooks/useDisabledRowTooltip';

interface DisabledRowTooltipProps {
  position: TooltipPosition | null;
  message?: string;
  maxWidth?: string;
  zIndex?: number;
}

const DisabledRowTooltip: React.FC<DisabledRowTooltipProps> = ({
  position,
  message = 'Row is disabled',
  maxWidth = '300px',
  zIndex = 9999,
}) => {
  if (!position) return null;

  const virtualAnchor = {
    clientHeight: 0,
    clientWidth: 0,
    getBoundingClientRect: () => ({
      top: position.y,
      left: position.x,
      right: position.x,
      bottom: position.y,
      width: 0,
      height: 0,
      x: position.x,
      y: position.y,
      toJSON: () => {},
    }),
  };

  return (
    <Popper
      open={true}
      anchorEl={virtualAnchor as any}
      placement="bottom-start"
      style={{ zIndex }}
    >
      <Paper style={{ padding: '4px 8px', fontSize: '12px', maxWidth }}>
        {message}
      </Paper>
    </Popper>
  );
};

export default DisabledRowTooltip;
